import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
} from "@stripe/react-stripe-js";
import SubscribeForm from "../../components/stripe/SubscribeForm";
import { useParams } from "react-router-dom";

// Load Stripe with your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

export default function Subscriptions() {
  const { id: orgId } = useParams();

  return (
    <Elements stripe={stripePromise}>
      <SubscribeForm selectedOrgId={orgId} />
    </Elements>
  );
}
